import { render, staticRenderFns } from "./NoteSendIcon.vue?vue&type=template&id=c047112a&"
import script from "./NoteSendIcon.vue?vue&type=script&lang=js&"
export * from "./NoteSendIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports